import React, { useContext, useState } from 'react'
import './ProgPanel.css'
import { TbPlayerTrackNext, TbPlayerTrackPrev } from 'react-icons/tb'
import { TikiaContext } from './Tikia'
import useOperatorStorage from '../../hooks/localStorage/useOperatorStorage';

export default function ProgPanel({stageId, task}) {
  const {stages, sortedStageKeys, updateTask} = useContext(TikiaContext);  
  const {operator} = useOperatorStorage();  

  const edgeStage = { t: '|' }
  const curPos = sortedStageKeys.indexOf(stageId);
  const maxPos = sortedStageKeys.length -1;
  const nextStageId = curPos < maxPos ? sortedStageKeys[curPos+1] : null;
  const prevStageId = curPos > 0 ? sortedStageKeys[curPos-1] : null;
  const prevStage = prevStageId ? stages[prevStageId] : edgeStage;
  const nextStage = nextStageId ? stages[nextStageId] : edgeStage;
  const stage = stages[stageId];
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);

  
  const handlePrev = (e) => {
    e.stopPropagation();
    updateTask({
      taskId: task.taskId,
      fieldName: 'stageId',
      fieldValue: prevStageId,
      teamId: operator.selectedTeamId,
      accountId: operator.accountId  
    });
  }
  
  const handleNext = (e) => {
    e.stopPropagation();
    updateTask({
      taskId: task.taskId,
      fieldName: 'stageId',
      fieldValue: nextStageId,
      teamId: operator.selectedTeamId,
      accountId: operator.accountId
    });    
  }

  const onMouseEnterPrev = (e) => {
    setShowPrev(true);
  }

  const onMouseLeavePrev = (e) => {
    setShowPrev(false);
  }

  const onMouseEnterNext = (e) => {
    setShowNext(true);    
  }

  const onMouseLeaveNext = (e) => {
    setShowNext(false);
  }

  
  return (
    <div className='progPanel'>
      <div className='progTitle'>
        {stage.t}
      </div>
      <div className='progButtons'>
        <div className='progButton' onMouseEnter={onMouseEnterPrev} onMouseLeave={onMouseLeavePrev} onClick={handlePrev}>
          <TbPlayerTrackPrev size={16}/>
        </div>
        <div className='progButton' onMouseEnter={onMouseEnterNext} onMouseLeave={onMouseLeaveNext} onClick={handleNext}>
          <TbPlayerTrackNext size={16}/>
        </div>
      </div>
      <div className='progStages'>
          {showPrev && <div className='progStage Prev'>{prevStage.t}</div>}
          {!showPrev && <div className='emptyStage Prev'> </div>}

          {showNext && <div className='progStage Next'>{nextStage.t}</div>}
          {!showNext && <div className='emptyStage Next'> </div>}
      </div>

      <div className='progLegend'>
        o o o ({stage.p}%) o o o o 
      </div>
    </div>
  )
}
